<template>
  <form-label-group :label="calcLabel" :class="{ 'mb-2': showErrorSpacing }">
    <b-form-input
      ref="field"
      :value="innerValue"
      :type="type"
      :disabled="disabled"
      :readonly="readonly"
      :required="required"
      :placeholder="calcPlaceholder"
      :size="size"
      class="b-custom-input"
      @blur="$emit('blur', innerValue)"
      @focus="$emit('focus', $event)"
      @input="onInput($event)"
    />
  </form-label-group>
</template>

<script>
import FormLabelGroup from '@/components/organisation/FormLabelGroup';

export default {
  name: 'BCustomInput',

  components: {
    FormLabelGroup,
  },

  props: {
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    value: {
      type: null,
    },
    type: {
      type: String,
    },
    readonly: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    showErrorSpacing: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'lg',
    },
  },

  data() {
    return {
      innerValue: null,
    };
  },

  computed: {
    calcLabel() {
      return this.required ? this.label + ' *' : this.label;
    },

    calcPlaceholder() {
      return this.placeholder == null ? this.label : this.placeholder;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nextValue) {
        this.innerValue = nextValue;
      },
    },
  },

  methods: {
    onInput(value) {
      this.innerValue = value;
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped>
/** @todo Move it to Bottstrap's field customization. */
.b-custom-input {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/BCustomInput.vue